import { getProductCategories } from "@hardware/Services/CustomProductService";
import { setGA4Event } from "@hardware/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";

addToChainAfter(chain, PopulateApiParameter, async props => {
    const state = props.getState();
    const currentCart = state.data.carts.byId[props.apiParameter.cartId];
    const cartLine = currentCart?.cartLines?.find(cl => cl.id === props.parameter.cartLineId);

    if (!cartLine) {
        return;
    }

    const result = await getProductCategories({
        productIds: [cartLine?.productId ?? ""],
        type: "product",
    });

    if (result.successful) {
        const productProperties = result.result.productProperties;
        setGA4Event("remove_from_cart", [cartLine], {
            productProperties,
        });
    }
});
